import { FC } from "react";

import { IRadioButtonProps } from "./types";
import { Label, LabelWrapper, Radio, RadioInput, Wrapper } from "./styles";

const RadioButton: FC<IRadioButtonProps> = ({
  name,
  value,
  id,
  onChange,
  label,
  className,
  isDisabled,
}) => {
  const isChecked = id === value;

  return (
    <Wrapper className={className} disabled={isDisabled}>
      <LabelWrapper onChange={() => onChange(id)}>
        <RadioInput type="radio" checked={isChecked} name={name} />
        <Radio className={isChecked ? "checked" : ""}>{isChecked && <div />}</Radio>
        {label && <Label>{label}</Label>}
      </LabelWrapper>
    </Wrapper>
  );
};

export default RadioButton;
